import { OutlinedIcons } from '@marageti/z4-lib';
import { SvgIconProps } from '@mui/material';

export type Reminder = {
  reminder: string;
  title: string;
  description: string;
  icon: (props: SvgIconProps<'svg', {}>) => JSX.Element;
  longDescription: string;
};

export const ReminderMap: Record<string, (Reminder | undefined)[]> = {
  FIRST_MESSAGE_SENT: [
    undefined, // 0
    { // reminder index 1
      reminder: '1st-phone-call',
      title: '1st Phone Call',
      description: 'Make the first phone call attempt to get the conversation started.',
      icon: OutlinedIcons.OutlinedPhoneOutgoingIcon,
      longDescription: 'Make the first phone call attempt to get the conversation started. Don\'t forget to log your call attempts here to track your progress.',
    },
    { // reminder index 2
      reminder: '2nd-phone-call',
      title: '2nd Phone Call',
      description: 'Make the second phone call attempt to get the conversation started.',
      icon: OutlinedIcons.OutlinedPhoneOutgoingIcon,
      longDescription: 'Make the second phone call attempt to get the conversation started. Don\'t forget to log your call attempts here to track your progress.',
    },
    { // reminder index 3
      reminder: 'weekly-follow-up',
      title: 'Weekly Follow-Up',
      description: 'Send a message or try another call to get the conversation started.',
      icon: OutlinedIcons.OutlinedCalendarIcon,
      longDescription: 'Send a message or try another call to get the conversation started. Don\'t forget to log your call attempts here to track your progress.',
    },
    { // reminder index 4
      reminder: 'weekly-follow-up',
      title: 'Weekly Follow-Up',
      description: 'Send a message or try another call to get the conversation started.',
      icon: OutlinedIcons.OutlinedCalendarIcon,
      longDescription: 'Send a message or try another call to get the conversation started. Don\'t forget to log your call attempts here to track your progress.',
    },
    { // reminder index 5
      reminder: 'weekly-follow-up',
      title: 'Weekly Follow-Up',
      description: 'Send a message or try another call to get the conversation started.',
      icon: OutlinedIcons.OutlinedCalendarIcon,
      longDescription: 'Send a message or try another call to get the conversation started. Don\'t forget to log your call attempts here to track your progress.',
    },
    { // reminder index 6
      reminder: 'weekly-follow-up',
      title: 'Weekly Follow-Up',
      description: 'Send a message or try another call to get the conversation started.',
      icon: OutlinedIcons.OutlinedCalendarIcon,
      longDescription: 'Send a message or try another call to get the conversation started. Don\'t forget to log your call attempts here to track your progress.',
    },
    { // reminder index 7
      reminder: 'monthly-follow-up',
      title: 'Monthly Follow-Up',
      description: 'Send a message or try another call to get the conversation started.',
      icon: OutlinedIcons.OutlinedCalendarIcon,
      longDescription: 'Send a message or try another call to get the conversation started. Don\'t forget to log your call attempts here to track your progress.',
    },
    { // reminder index 8
      reminder: 'monthly-follow-up',
      title: 'Monthly Follow-Up',
      description: 'Send a message or try another call to get the conversation started.',
      icon: OutlinedIcons.OutlinedCalendarIcon,
      longDescription: 'Send a message or try another call to get the conversation started. Don\'t forget to log your call attempts here to track your progress.',
    },
    { // reminder index 9
      reminder: 'inactive-lead',
      title: 'Final Message',
      description: 'Send a polite farewell message and mark the trip as inactive.',
      icon: OutlinedIcons.OutlinedEmojiSadIcon,
      longDescription: 'The traveler hasn\'t responded after multiple follow-up attempts. Please send a polite farewell message and mark the trip as Inactive to keep your workspace organized.',
    },
  ],
  CONSULTATION: [
    undefined, // 0
    { // reminder index 1
      reminder: 'send-proposal',
      title: 'Send Trip Proposal',
      description: 'Send the first itinerary proposal and keep the trip planning moving!',
      icon: OutlinedIcons.OutlinedMapIcon,
      longDescription: 'Upload the first itinerary and keep the trip planning moving! Travelers tend to be more engaged once they receive a personalized itinerary.',
    },
    { // reminder index 2
      reminder: 'send-proposal',
      title: 'Send Trip Proposal',
      description: 'Send the first itinerary proposal and keep the trip planning moving!',
      icon: OutlinedIcons.OutlinedMapIcon,
      longDescription: 'Upload the first itinerary and keep the trip planning moving! Travelers tend to be more engaged once they receive a personalized itinerary.',
    },
    { // reminder index 3
      reminder: 'send-proposal',
      title: 'Send Trip Proposal',
      description: 'Send the first itinerary proposal and keep the trip planning moving!',
      icon: OutlinedIcons.OutlinedMapIcon,
      longDescription: 'Upload the first itinerary and keep the trip planning moving! Travelers tend to be more engaged once they receive a personalized itinerary.',
    },
    { // reminder index 4
      reminder: 'send-proposal',
      title: 'Send Trip Proposal',
      description: 'Send the first itinerary proposal and keep the trip planning moving!',
      icon: OutlinedIcons.OutlinedMapIcon,
      longDescription: 'Upload the first itinerary and keep the trip planning moving! Travelers tend to be more engaged once they receive a personalized itinerary.',
    },
    { // reminder index 5
      reminder: 'send-proposal',
      title: 'Send Trip Proposal',
      description: 'Send the first itinerary proposal and keep the trip planning moving!',
      icon: OutlinedIcons.OutlinedMapIcon,
      longDescription: 'Upload the first itinerary and keep the trip planning moving! Travelers tend to be more engaged once they receive a personalized itinerary.',
    },
    { // reminder index 6
      reminder: 'send-proposal',
      title: 'Send Trip Proposal',
      description: 'Send the first itinerary proposal and keep the trip planning moving!',
      icon: OutlinedIcons.OutlinedMapIcon,
      longDescription: 'Upload the first itinerary and keep the trip planning moving! Travelers tend to be more engaged once they receive a personalized itinerary.',
    },
    { // reminder index 7
      reminder: 'send-proposal',
      title: 'Send Trip Proposal',
      description: 'Send the first itinerary proposal and keep the trip planning moving!',
      icon: OutlinedIcons.OutlinedMapIcon,
      longDescription: 'Upload the first itinerary and keep the trip planning moving! Travelers tend to be more engaged once they receive a personalized itinerary.',
    },
    { // reminder index 8
      reminder: 'send-proposal',
      title: 'Send Trip Proposal',
      description: 'Send the first itinerary proposal and keep the trip planning moving!',
      icon: OutlinedIcons.OutlinedMapIcon,
      longDescription: 'Upload the first itinerary and keep the trip planning moving! Travelers tend to be more engaged once they receive a personalized itinerary.',
    },
    { // reminder index 9
      reminder: 'inactive-lead',
      title: 'Final Message',
      description: 'Send a polite farewell message and mark the trip as inactive.',
      icon: OutlinedIcons.OutlinedEmojiSadIcon,
      longDescription: 'The traveler hasn\'t responded after multiple follow-up attempts. Please send a polite farewell message and mark the trip as Inactive to keep your workspace organized.',
    },
  ],
  ITINERARY_SENT: [
    undefined, // 0
    { // reminder index 1
      reminder: 'itinerary-follow-up',
      title: 'Trip Proposal Follow-Up',
      description: 'Follow up with the traveler about the itinerary proposal you sent.',
      icon: OutlinedIcons.OutlinedMapIcon,
      longDescription: 'Follow up with the traveler about the itinerary you sent. Don\'t forget to log your call attempts here to track your progress.',
    },
    { // reminder index 2
      reminder: 'itinerary-follow-up',
      title: 'Trip Proposal Follow-Up',
      description: 'Follow up with the traveler about the itinerary proposal you sent.',
      icon: OutlinedIcons.OutlinedMapIcon,
      longDescription: 'Follow up with the traveler about the itinerary you sent. Don\'t forget to log your call attempts here to track your progress.',
    },
    { // reminder index 3
      reminder: 'itinerary-follow-up',
      title: 'Trip Proposal Follow-Up',
      description: 'Follow up with the traveler about the itinerary proposal you sent.',
      icon: OutlinedIcons.OutlinedMapIcon,
      longDescription: 'Follow up with the traveler about the itinerary you sent. Don\'t forget to log your call attempts here to track your progress.',
    },
    { // reminder index 4
      reminder: 'itinerary-follow-up',
      title: 'Trip Proposal Follow-Up',
      description: 'Follow up with the traveler about the itinerary proposal you sent.',
      icon: OutlinedIcons.OutlinedMapIcon,
      longDescription: 'Follow up with the traveler about the itinerary you sent. Don\'t forget to log your call attempts here to track your progress.',
    },
    { // reminder index 5
      reminder: 'itinerary-follow-up',
      title: 'Trip Proposal Follow-Up',
      description: 'Follow up with the traveler about the itinerary proposal you sent.',
      icon: OutlinedIcons.OutlinedMapIcon,
      longDescription: 'Follow up with the traveler about the itinerary you sent. Don\'t forget to log your call attempts here to track your progress.',
    },
    { // reminder index 6
      reminder: 'itinerary-follow-up',
      title: 'Trip Proposal Follow-Up',
      description: 'Follow up with the traveler about the itinerary proposal you sent.',
      icon: OutlinedIcons.OutlinedMapIcon,
      longDescription: 'Follow up with the traveler about the itinerary you sent. Don\'t forget to log your call attempts here to track your progress.',
    },
    { // reminder index 7
      reminder: 'itinerary-follow-up',
      title: 'Trip Proposal Follow-Up',
      description: 'Follow up with the traveler about the itinerary proposal you sent.',
      icon: OutlinedIcons.OutlinedMapIcon,
      longDescription: 'Follow up with the traveler about the itinerary you sent. Don\'t forget to log your call attempts here to track your progress.',
    },
    { // reminder index 8
      reminder: 'itinerary-follow-up',
      title: 'Trip Proposal Follow-Up',
      description: 'Follow up with the traveler about the itinerary proposal you sent.',
      icon: OutlinedIcons.OutlinedMapIcon,
      longDescription: 'Follow up with the traveler about the itinerary you sent. Don\'t forget to log your call attempts here to track your progress.',
    },
    { // reminder index 9
      reminder: 'inactive-lead',
      title: 'Final Message',
      description: 'Send a polite farewell message and mark the trip as inactive.',
      icon: OutlinedIcons.OutlinedEmojiSadIcon,
      longDescription: 'The traveler hasn\'t responded after multiple follow-up attempts. Please send a polite farewell message and mark the trip as Inactive to keep your workspace organized.',
    },
  ],
  ITINERARY_IN_REVIEW: [
    undefined, // 0
    { // reminder index 1
      reminder: 'weekly-follow-up',
      title: 'Weekly Follow-Up',
      description: 'Keep the traveler engaged with a follow-up message or call about their itinerary.',
      icon: OutlinedIcons.OutlinedCalendarIcon,
      longDescription: 'Keep the traveler engaged with a follow-up message or call about their itinerary. Don\'t forget to log your call attempts here to track your progress.',
    },
    { // reminder index 2
      reminder: 'weekly-follow-up',
      title: 'Weekly Follow-Up',
      description: 'Keep the traveler engaged with a follow-up message or call about their itinerary.',
      icon: OutlinedIcons.OutlinedCalendarIcon,
      longDescription: 'Keep the traveler engaged with a follow-up message or call about their itinerary. Don\'t forget to log your call attempts here to track your progress.',
    },
    { // reminder index 3
      reminder: 'weekly-follow-up',
      title: 'Weekly Follow-Up',
      description: 'Keep the traveler engaged with a follow-up message or call about their itinerary.',
      icon: OutlinedIcons.OutlinedCalendarIcon,
      longDescription: 'Keep the traveler engaged with a follow-up message or call about their itinerary. Don\'t forget to log your call attempts here to track your progress.',
    },
    { // reminder index 4
      reminder: 'weekly-follow-up',
      title: 'Weekly Follow-Up',
      description: 'Keep the traveler engaged with a follow-up message or call about their itinerary.',
      icon: OutlinedIcons.OutlinedCalendarIcon,
      longDescription: 'Keep the traveler engaged with a follow-up message or call about their itinerary. Don\'t forget to log your call attempts here to track your progress.',
    },
    { // reminder index 5
      reminder: 'monthly-follow-up',
      title: 'Monthly Follow-Up',
      description: 'Keep the traveler engaged with a follow-up message or call about their itinerary.',
      icon: OutlinedIcons.OutlinedCalendarIcon,
      longDescription: 'Keep the traveler engaged with a follow-up message or call about their itinerary. Don\'t forget to log your call attempts here to track your progress.',
    },
    { // reminder index 6
      reminder: 'monthly-follow-up',
      title: 'Monthly Follow-Up',
      description: 'Keep the traveler engaged with a follow-up message or call about their itinerary.',
      icon: OutlinedIcons.OutlinedCalendarIcon,
      longDescription: 'Keep the traveler engaged with a follow-up message or call about their itinerary. Don\'t forget to log your call attempts here to track your progress.',
    },
    { // reminder index 7
      reminder: 'inactive-lead',
      title: 'Final Message',
      description: 'Send a polite farewell message and mark the trip as inactive.',
      icon: OutlinedIcons.OutlinedEmojiSadIcon,
      longDescription: 'The traveler hasn\'t responded after multiple follow-up attempts. Please send a polite farewell message and mark the trip as Inactive to keep your workspace organized.',
    },
  ],
};

export const getDueStatus = (reminder: { dueAt: string, index: number }): { isDue: boolean, isOverdue: boolean } => {
  if (!reminder.dueAt) {
    return { isDue: false, isOverdue: false };
  }
  if (reminder.index === -1) {
    return { isDue: false, isOverdue: false };
  }
  if (reminder.index === 0) {
    return { isDue: false, isOverdue: false };
  }
  const dueDate = new Date(reminder.dueAt);
  const now = new Date();

  const msIn24Hours = 24 * 60 * 60 * 1000;
  const diff = dueDate.getTime() - now.getTime();

  const isDue = diff >= 0 && diff <= msIn24Hours;
  const isOverdue = diff < 0;

  return { isDue, isOverdue };
};
